import type { IconNode } from '../types';

/**
 * @name bowl-overflow
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNEM2LjUgNCAyIDYuMiAyIDljMCAyLjQgMy40IDQuNCA4IDQuOSAxLjEuMSAyIDEgMiAyLjF2M2EyIDIgMCAwIDAgNCAwdi0zLjRjMC0xLjEuOS0yLjIgMS45LTIuNiAyLjUtLjkgNC4xLTIuNCA0LjEtNCAwLTIuOC00LjUtNS0xMC01IiAvPgogIDxwYXRoIGQ9Ik0yIDljMCA1LjUgNC41IDEwIDEwIDEwIiAvPgogIDxwYXRoIGQ9Ik0xNiAxOC4yYzMuNS0xLjUgNi01LjEgNi05LjIiIC8+CiAgPHBhdGggZD0iTTE2IDE1LjZjMC0yLjYgMy0yLjYgMy00LjYgMC0xLjctMy4xLTMtNy0zcy03IDEuMy03IDNjMCAxLjQgMi4xIDIuNSA1IDIuOSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/bowl-overflow
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bowlOverflow: IconNode = [
  [
    'path',
    {
      d: 'M12 4C6.5 4 2 6.2 2 9c0 2.4 3.4 4.4 8 4.9 1.1.1 2 1 2 2.1v3a2 2 0 0 0 4 0v-3.4c0-1.1.9-2.2 1.9-2.6 2.5-.9 4.1-2.4 4.1-4 0-2.8-4.5-5-10-5',
      key: 'n12y70',
    },
  ],
  ['path', { d: 'M2 9c0 5.5 4.5 10 10 10', key: '1ayzqr' }],
  ['path', { d: 'M16 18.2c3.5-1.5 6-5.1 6-9.2', key: 'm5hso6' }],
  [
    'path',
    {
      d: 'M16 15.6c0-2.6 3-2.6 3-4.6 0-1.7-3.1-3-7-3s-7 1.3-7 3c0 1.4 2.1 2.5 5 2.9',
      key: '1jw8kc',
    },
  ],
];

export default bowlOverflow;
